import React, { useState } from 'react';
import { Drawer } from 'antd';

import styles from './index.module.scss';
import { BurgerIcon } from '../../Common/Icon';

export const navLinks = [
  { text: 'Versenden mit Sephyre', link: 'https://www.sephyre.com/#Versenden-mit-Sephyre' },
  { text: 'So läuft der Versand ab', link: 'https://www.sephyre.com/#So-läuft-de-Versand-ab' },
  { text: 'Über Sephyre', link: 'https://www.sephyre.com/#Über-Sephyre' },
  { text: 'FAQ', link: 'https://www.sephyre.com/#FAQ' },
  { text: 'Login', link: 'https://portal.sephyre.com/', onlyMobile: false },
];

export default function Header(): React.ReactNode {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div className={styles.header}>
      <div>
        <a href="https://www.sephyre.com/">
          <img src="/media/logo-dark.png" alt="Logo" className={styles.logo} />
        </a>
      </div>
      <div className={styles.links}>
        {navLinks
          .filter((i) => !i.onlyMobile)
          .map((item) => (
            <a key={item.text} href={item.link} target="_blank" rel="noreferrer">
              {item.text}
            </a>
          ))}
      </div>

      <div className={styles.menu} id="mobileMenu">
        <div className={styles.menuButton}>
          <BurgerIcon onClick={showDrawer} />
        </div>
        <Drawer
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
          style={{ backgroundColor: 'var(--header-bg)' }}
          bodyStyle={{ padding: '30px' }}
          width={300}
        >
          <div className={styles.menuItems}>
            {navLinks.map((item) => (
              <a key={item.text} href={item.link} target="_blank" rel="noreferrer">
                {item.text}
              </a>
            ))}
          </div>
        </Drawer>

      </div>
    </div>
  );
}
